import { Routes } from '@angular/router';
import { ChangePasswordPageComponent, MainLayoutComponent } from './core/containers';
import { NotLoggedInGuard } from '@ml/auth/guards';
import * as coreGuards from './core/guards';
import { AdminGuard } from './core/guards';
import { NotFoundComponent } from '@ml/core/components/not-found/not-found.component';
import { EmployeeGuard } from '@ml/core/guards/employee.guard';
import { CustomerGuard } from '@ml/core/guards/customer.guard';
import { AdminPhoneGuard } from '@ml/core/guards/admin-phone.guard';
var ɵ0 = function () {
    return import("./machineries/machineries.module.ngfactory").then(function (m) { return m.MachineriesModuleNgFactory; });
}, ɵ1 = function () {
    return import("./orders/orders.module.ngfactory").then(function (m) { return m.OrdersModuleNgFactory; });
}, ɵ2 = function () {
    return import("./customers/customers.module.ngfactory").then(function (m) { return m.CustomersModuleNgFactory; });
}, ɵ3 = function () {
    return import("./suppliers/suppliers.module.ngfactory").then(function (m) { return m.SuppliersModuleNgFactory; });
}, ɵ4 = function () {
    return import("./services/services.module.ngfactory").then(function (m) { return m.ServicesModuleNgFactory; });
}, ɵ5 = function () {
    return import("./accounting/accounting.module.ngfactory").then(function (m) { return m.AccountingModuleNgFactory; });
}, ɵ6 = function () {
    return import("./employees/employees.module.ngfactory").then(function (m) { return m.EmployeesModuleNgFactory; });
}, ɵ7 = function () {
    return import("./tasks/tasks.module.ngfactory").then(function (m) { return m.TasksModuleNgFactory; });
}, ɵ8 = { preload: true }, ɵ9 = function () {
    return import("./salaries/salaries.module.ngfactory").then(function (m) { return m.SalariesModuleNgFactory; });
}, ɵ10 = { preload: true }, ɵ11 = function () {
    return import("./customer-orders/customer-orders.module.ngfactory").then(function (m) { return m.CustomerOrdersModuleNgFactory; });
}, ɵ12 = function () {
    return import("./locations/locations.module.ngfactory").then(function (m) { return m.LocationsModuleNgFactory; });
};
var routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [coreGuards.AuthGuard],
        children: [
            {
                path: 'machineries',
                canActivate: [AdminGuard],
                loadChildren: ɵ0
            },
            {
                path: 'orders',
                loadChildren: ɵ1,
                canActivate: [AdminGuard]
            },
            {
                path: 'customers',
                loadChildren: ɵ2,
                canActivate: [AdminGuard]
            },
            {
                path: 'suppliers',
                loadChildren: ɵ3,
                canActivate: [AdminGuard]
            },
            {
                path: 'services',
                loadChildren: ɵ4,
                canActivate: [AdminGuard]
            },
            {
                path: 'accounting',
                loadChildren: ɵ5,
                canActivate: [AdminGuard]
            },
            {
                path: 'employees',
                loadChildren: ɵ6,
                canActivate: [AdminGuard]
            },
            {
                path: 'tasks',
                loadChildren: ɵ7,
                data: ɵ8,
                canActivate: [EmployeeGuard]
            },
            {
                path: 'salaries',
                loadChildren: ɵ9,
                data: ɵ10,
                canActivate: [EmployeeGuard]
            },
            {
                path: 'customer-orders',
                loadChildren: ɵ11,
                canActivate: [CustomerGuard]
            },
            {
                path: 'locations',
                loadChildren: ɵ12,
                canActivate: [CustomerGuard]
            },
            {
                path: '',
                pathMatch: 'full',
                canActivate: [AdminPhoneGuard],
                children: []
            }
        ]
    },
    {
        path: 'auth',
        canActivate: [NotLoggedInGuard],
        loadChildren: './auth/auth.module#AuthModule'
    },
    {
        path: 'change-password',
        // canActivate: [FirstTimeLoginGuard],
        component: ChangePasswordPageComponent
    },
    { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
    { path: 'not-found', component: NotFoundComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12 };
